<template>
  <a-layout class="myApplication">
    <a-card :bordered="false">
      <search-form :search-conditions="searchConditions" :show-advanced="showAdvanced" :query-params="queryParams" @query="query" @update-option="fetchOptList" @update-params="updateParams"></search-form>
      <a-table :columns="columns" :rowKey="record => record.apply_number || record.id" :dataSource="dataSource" :pagination="false" :customRow="customRow" :loading="loading">
        <template slot="titleRender" slot-scope="text, record">
          <span>{{record.user_name}}提交的{{record.apply_type}}</span>
        </template>

        <template slot="abstractRender" slot-scope="text, record">
          <p v-if="record.form_type===7">申请类型：采购申请</p>
          <p v-else-if="record.form_type===6">申请类型：{{record.apply_detail_type}}</p>
          <div v-else>
            <p>{{record.apply_type}}类型：{{record.apply_detail_type}}</p>
            <p v-if="record.payee_name">收款方：{{record.payee_name}}</p>
            <p v-if="record.form_type!==6">{{record.apply_type}}总金额（{{record.money_type}}）：{{record.total_pay}}</p>
          </div>
        </template>

        <template slot="statusRender" slot-scope="text, record">
          <span :style="setStatusColor(text)">{{text}}</span>
        </template>

        <template slot="footer" slot-scope="currentPageData" v-if="dataSource.length<total">
          <p style="text-align:center;">
            <span @click="loadMore" style="cursor:pointer">加载更多数据</span>
          </p>
        </template>
      </a-table>
    </a-card>
  </a-layout>
</template>

<script>
import SearchForm from "../../components/SearchForm.vue";
import { getList } from "../../services/ApprovedByMeListService";
import {
  getStatusOptions,
  ApplyTypeUrl,
  StatusTypeListUrl,
  ApplyPersonUrl,
  getSearchOptions
} from "../../services/CommonService";

export default {
  components: {
    SearchForm
  },
  data() {
    return {
      showAdvanced: false,
      loading: true,
      breadcrumb: [
        {
          label: "我已审批",
          path: ""
        }
      ],
      cardHeight: 0,
      searchConditions: [
        [
          {
            label: "申请类型",
            type: "select",
            field: "applyType",
            placeholder: "请选择",
            fetch: {
              url: ApplyTypeUrl,
              params: {}
            },
            options: [],
            hasAll: true,
            triggerField: "applierId"
            // needDefault: true,
          },
          {
            label: "申请人",
            type: "complexSelect",
            field: "applierId",
            placeholder: "请选择",
            fetch: {
              url: ApplyPersonUrl,
              params: {}
            },
            options: []
          },
          {
            label: "状态",
            type: "select",
            field: "status",
            placeholder: "请选择",
            fetch: {
              url: StatusTypeListUrl,
              params: {
                usage: "approved_by_me"
              }
            },
            options: []
          },
          {
            show: true,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "提交审批时间",
            type: "range",
            field: "applyTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "审批完成时间",
            type: "range",
            field: "approvedTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ],
        [
          {
            label: "付款完成时间",
            type: "range",
            field: "paidTime"
          },
          {
            show: false,
            type: "btnGroup"
          }
        ]
      ],
      columns: [
        {
          title: "申请标题",
          dataIndex: "title",
          width: 150,
          scopedSlots: { customRender: "titleRender" }
        },
        {
          title: "申请摘要",
          dataIndex: "abstract",
          width: 250,
          scopedSlots: { customRender: "abstractRender" }
        },
        {
          title: "发起时间",
          dataIndex: "apply_time",
          width: 150
        },
        {
          title: "审批完成时间",
          dataIndex: "approved_time",
          width: 150
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 150,
          scopedSlots: { customRender: "statusRender" }
        }
      ],
      dataSource: [],
      total: 0,
      queryParams: {
        currentPage: 1,
        pageSize: 20,
        filter: "approved_by_me",

        applyType: undefined,
        applierId: undefined,
        status: undefined,
        applyTime: [],
        // applyTimeEnd: undefined,
        approvedTime: [],
        // approvedTimeEnd: undefined,
        paidTime: []
        // paidTimeEnd: undefined,
      }
    };
  },

  created() {
    this.queryParams.applyType = "all";
    this.queryParamsInit = _.cloneDeep(this.queryParams);
    this.cardHeight = document.documentElement.clientHeight - 150;
    const vm = this;
    window.onresize = function() {
      vm.cardHeight = document.documentElement.clientHeight - 150;
    };
    this.getList();
    this.searchConditions.forEach(item => {
      item.forEach(child => {
        if (child.fetch && child.fetch.url) {
          this.fetchOptList(child);
        }
      });
    });
  },

  computed: {
    queryObj() {
      return {
        current_page: this.queryParams.currentPage,
        page_size: this.queryParams.pageSize,
        filter: this.queryParams.filter,

        applier_id: this.queryParams.applierId,
        apply_type:
          this.queryParams.applyType === "all"
            ? undefined
            : this.queryParams.applyType,
        status: this.queryParams.status,
        apply_time_start: this.queryParams.applyTime[0],
        apply_time_end: this.queryParams.applyTime[1],
        approved_time_start: this.queryParams.approvedTime[0],
        approved_time_end: this.queryParams.approvedTime[1],
        paid_time_start: this.queryParams.paidTime[0],
        paid_time_end: this.queryParams.paidTime[1]
      };
    }
  },

  methods: {
    fetchOptList(config) {
      config.loading = true;
      if (config.field === "applierId") {
        config.fetch.params.apply_type =
          this.queryParams.applyType === "all"
            ? undefined
            : this.queryParams.applyType;
      }
      getSearchOptions(config.fetch.url, config.fetch.params).then(res => {
        if (res.status === "success") {
          config.options = res.data;
          if (config.hasAll) {
            config.options.unshift({
              id: "all",
              name: "全部"
            });
          }
        } else {
          this.$Message.error(res.message);
        }
        config.loading = false;
      });
    },

    updateParams(e) {
      const key = Object.keys(e)[0];
      this.queryParams[key] = e[key];
    },
    query(e) {
      this.queryParams = _.cloneDeep(this.queryParamsInit);
      Object.assign(this.queryParams, e);
      this.dataSource = [];
      this.getList();
    },

    getList() {
      this.loading = true;
      getList(this.queryObj).then(res => {
        if ((res.status = "success")) {
          this.total = res.total;
          this.dataSource = this.dataSource.concat(res.data);
        } else {
          this.$Message.error(res.message);
        }
        this.loading = false;
      });
    },

    loadMore() {
      this.queryParams.currentPage++;
      this.getList();
    },

    customRow(record) {
      let vm = this;
      return {
        on: {
          click(event) {
            if (record.form_type === 1)
              vm.$router.replace({
                name: "approvedByMeDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 2)
              vm.$router.replace({
                name: "approvedReimbursementDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 7)
              vm.$router.replace({
                name: "approvedPurchaseDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 6)
              vm.$router.replace({
                name: "approvedBudgetApplicationDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 8)
              vm.$router.replace({
                name: "approvedProExpendPaymentDetail",
                query: {
                  id: record.id
                }
              });
            if (record.form_type === 9)
              vm.$router.replace({
                name: "approvedProExpendReimbursementDetail",
                query: {
                  id: record.id
                }
              });
          }
        }
      };
    },
    setStatusColor(text) {
      if (text === "审批中") {
        return { color: "#FF9500" };
      } else if (text === "审批通过" || text === "付款成功") {
        return { color: "#2DBE60" };
      } else if (text === "审批拒绝" || text === "付款失败") {
        return { color: "#FF4D07" };
      } else if (text === "已撤回") {
        return { color: "rgba(0,0,0,0.38)" };
      }
    }
  }
};
</script>

<style lang="less">
.oa-app .myApplication {
  padding: 16px;
}
.dd-oa-app .myApplication {
  padding: 0;
  > .ant-card > .ant-card-body {
    padding: 24px 0;
  }
  .ant-advanced-search-form {
    padding: 0 32px;
  }
}
</style>
